import { useRef, useState } from "react";

const r2 = (v) => Math.round(v * 2) / 2;
const clamp = (v, a, b) => Math.min(b, Math.max(a, v));

export function useHeroDrag(setObjs, onBegin) {
  const [selected, setSelected] = useState(null);
  const [held, setHeld] = useState(null);
  const [guides, setGuides] = useState({});
  const st = useRef(null);

  const move = (e) => {
    const s = st.current; if (!s) return;
    const dx = ((e.clientX - s.sx) / s.rect.width) * 100, dy = ((e.clientY - s.sy) / s.rect.height) * 100;
    if (!s.moved && Math.abs(dx) + Math.abs(dy) < 0.3) return;
    if (!s.moved) { s.moved = true; onBegin(); setHeld(s.o.object_id); }
    const o = s.o, hOf = (w) => w * s.aspect * (s.rect.width / s.rect.height);
    let { x, y, width } = o; const g = {};
    if (s.kind === "move") {
      x = clamp(o.x + dx, -10, 100 - o.width * 0.5); y = clamp(o.y + dy, -10, 95);
      if (Math.abs(x + width / 2 - 50) < 1) { x = 50 - width / 2; g.v = true; }
      if (Math.abs(y + hOf(width) / 2 - 50) < 1) { y = 50 - hOf(width) / 2; g.h = true; }
    } else {
      const sign = s.kind.includes("w") ? -1 : 1;
      width = clamp(o.width + sign * dx, 3, 60);
      if (s.kind.includes("w")) x = clamp(o.x + (o.width - width), -10, 100);
      if (s.kind.includes("n")) y = clamp(o.y + (hOf(o.width) - hOf(width)), -10, 100);
    }
    setGuides(g);
    const patch = { x: r2(x), y: r2(y), width: r2(width) };
    setObjs((all) => all.map((a) => (a.object_id === o.object_id ? { ...a, ...patch } : a)));
  };
  const end = () => {
    window.removeEventListener("pointermove", move); window.removeEventListener("pointerup", end); window.removeEventListener("pointercancel", end);
    st.current = null; setHeld(null); setGuides({});
  };
  const start = (e, o, kind) => {
    e.preventDefault();
    const el = e.currentTarget.closest(".hero-obj"), box = el.getBoundingClientRect();
    st.current = { o, kind, sx: e.clientX, sy: e.clientY, rect: el.closest(".hero-art").getBoundingClientRect(), aspect: box.height / Math.max(1, box.width) || 1, moved: false };
    setSelected(o.object_id);
    window.addEventListener("pointermove", move); window.addEventListener("pointerup", end); window.addEventListener("pointercancel", end);
  };
  return { selected, setSelected, held, guides, start };
}
